import React from "react";

// Decorative animated background — static gradient with subtle motion
// (per user choice: NOT a video, NOT a heavy canvas animation)
export default function HeroBackground({ variant = "full" }) {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 nx-grid-bg opacity-60" />
      <div className="nx-orb b1" />
      <div className="nx-orb b2" />
      {variant === "full" && <div className="nx-orb b3" />}
      <Nodes />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#071A35] to-transparent" />
    </div>
  );
}

function Nodes() {
  const nodes = [
    { top: "18%", left: "12%", delay: "0s" },
    { top: "62%", left: "8%", delay: "1.2s" },
    { top: "28%", left: "82%", delay: "0.5s" },
    { top: "72%", left: "70%", delay: "1.8s" },
    { top: "48%", left: "44%", delay: "0.9s" },
    { top: "12%", left: "62%", delay: "2.4s" },
    { top: "84%", left: "30%", delay: "0.3s" },
  ];
  return (
    <>
      {nodes.map((n, i) => (
        <span
          key={i}
          className="nx-node"
          style={{ top: n.top, left: n.left, animationDelay: n.delay }}
        />
      ))}
      <svg
        className="absolute inset-0 w-full h-full opacity-[0.18]"
        viewBox="0 0 1200 800"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="line-grad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#0057FF" stopOpacity="0" />
            <stop offset="50%" stopColor="#38D8FF" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#0057FF" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g stroke="url(#line-grad)" strokeWidth="1" fill="none">
          <path d="M144 144 L984 224" />
          <path d="M96 496 L840 576" />
          <path d="M528 384 L744 144" />
          <path d="M360 672 L1080 384" />
        </g>
      </svg>
    </>
  );
}
